import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { CollectionResponseDto } from '../../../store/landscapeAPI/collection/dto/response/collection-response.dto';
import { Button, Label } from '../../atoms';
import {
  ReportingDetailsCollectionsForm,
  TranslationOrganism,
} from '../../organisms';
import BaseTemplate from '../BaseTemplate';
import cn from 'classnames';
import styles from './ReportingDetailsCollectionsAddTemplate.module.css';
import { LocalesLanguagesConstants } from '../../../locales/locales';
import { PromiseSettledResult } from '../../../utils/types/types';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';

export interface ReportingDetailsCollectionsAddTemplateProps {
  data: CollectionResponseDto;
  handleAddCollection: (goal: CollectionResponseDto) => void;
  handleOnChange: (goal: CollectionResponseDto) => void;
  handleImageOnChange: (imageMeta: ImageMeta) => void;
  setLanguage: React.Dispatch<React.SetStateAction<LocalesLanguagesConstants>>;
  selectedLanguage: LocalesLanguagesConstants;
  fromLanguage: LocalesLanguagesConstants;
  setFromLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  toLanguage: LocalesLanguagesConstants;
  setToLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  generateTranslation: () => Promise<void>;
  generateAllTranslations: () => Promise<PromiseSettledResult<void>[]>;
}

const ReportingDetailsCollectionsAddTemplate: FC<
  ReportingDetailsCollectionsAddTemplateProps
> = ({
  data,
  handleAddCollection,
  handleOnChange,
  handleImageOnChange,
  setLanguage,
  selectedLanguage,
  fromLanguage,
  setFromLanguage,
  toLanguage,
  setToLanguage,
  generateTranslation,
  generateAllTranslations,
}) => {
  const navigate = useNavigate();
  return (
    <BaseTemplate>
      <div className={styles.heading}>
        <Label content="Create Collection" size="lg" />
        <Button
          variant="link"
          onClick={() => navigate('/reporting-details/collections')}
          className={cn(styles.buttonLink)}
        >
          Go back to goal overview
        </Button>
      </div>
      <TranslationOrganism
        setLanguage={setLanguage}
        selectedLanguage={selectedLanguage}
        fromLanguage={fromLanguage}
        setFromLanguage={setFromLanguage}
        toLanguage={toLanguage}
        setToLanguage={setToLanguage}
        generateTranslation={generateTranslation}
        generateAllTranslations={generateAllTranslations}
      />
      <ReportingDetailsCollectionsForm
        data={data}
        callbackFn={handleAddCollection}
        handleOnChange={handleOnChange}
        handleImageOnChange={handleImageOnChange}
      />
    </BaseTemplate>
  );
};

export default ReportingDetailsCollectionsAddTemplate;
